import React from "react";
import { TabView, TabPanel } from "primereact/tabview";
import CsvUploader from "./CsvUploader";
import VentasPorAgencia from "./VentasPorAgencia";
import VentasPorAgenciaYJuego from "./VentasPorAgenciaYJuego";
import VentasPorHoraYJuego from "./VentasPorHoraYJuego";
import VentasPorHora from "./VentasPorHora";
import VentasPorJuego from "./VentasPorJuego";
import CalculadoraIncrementos from "./CalculadoraIncrementos";

const EstadisticasPanel = () => {
  return (
    <div id="panelEstadisticas" style={{
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      padding: '10px',
      borderRadius: '5px',
      width: '100%',
      maxWidth: '100%',
      margin: '0'
    }}>
      <center>
        <h1 className="botonbordeazul text-white px-5 mx-5 py-3 h1">Panel de Estadísticas</h1>
      </center>

      <TabView style={{ width: '100%' }}>
       {/*  <TabPanel header="Carga de CSV">
          <div style={{ padding: '10px' }}>
            <CsvUploader />
          </div>
        </TabPanel> */}
        <TabPanel header="Ventas por Agencia">
          <div style={{ padding: '10px' }}>
            <VentasPorAgencia />
          </div>
        </TabPanel>
        <TabPanel header="Calculadora">
          <div style={{ padding: '10px' }}>
            <CalculadoraIncrementos />
          </div>
        </TabPanel>
        <TabPanel header="Ventas por Agencia y Juego">
          <div style={{ padding: '10px' }}>
            <VentasPorAgenciaYJuego />
          </div>
        </TabPanel>
        <TabPanel header="Ventas por Hora y Juego">
          <div style={{ padding: '10px' }}>
            <VentasPorHoraYJuego />
          </div></TabPanel>
         <TabPanel header="Ventas por Hora">
          <div style={{ padding: '10px' }}>
            <VentasPorHora />
          </div></TabPanel>
          <TabPanel header="Ventas por Juego">
          <div style={{ padding: '10px' }}>
            <VentasPorJuego />
          </div></TabPanel>


        {/* Agregá más TabPanel aquí si querés expandir funcionalidades */}
      </TabView>
    </div>
  );
};

export default EstadisticasPanel;
